import { getPaymentType, unBind } from "@/apis/user";
import { usePaymentsStore } from "@/stores/payments";
import { Toast } from "antd-mobile";
import { useParams } from "react-router-dom";

export const useSetup = () => {
  const params = useParams();
  const paymentsStore = usePaymentsStore();

  const fetchPaymentTypes = async () => {
    const result = await getPaymentType({
      page: 1,
      pageSize: 9999,
    });
    if (result.ok && result.data && Array.isArray(result.data?.list)) {
      paymentsStore.setPayments(result.data?.list);
    }
  };

  // export const verifySecuretedCode = vm => {
  //   vm.$toast('请输入资金密码')
  //   return new Promise((resolve, reject) => {
  //     vm.$root.showPassowordKeyboard = true
  //     vm.$root.$once('root:global-password', async code => resolve(code))
  //   })
  // }

  const unbind = async ({
    id,
    securePassword,
  }: {
    securePassword: string;
    id: number | string;
  }) => {
    // if(!isPassed) return
    // const securePassword = await verifySecuretedCode(this)
    // if (securePassword && securePassword.length === 6) {
    const { ok, msg } = await unBind({ id, securePassword });
    if (ok) {
      fetchPaymentTypes();
    } else {
      Toast.show(msg);
    }
    // }else{
    //   Toast.show("资金密码有误！请重试")
    // }
  };

  return {
    pageType: params.type ? params.type : 'normal',
    isCryptoMerchant: params.type === 'merchant' || params.type === 'professionBusiness',
    isProfession: params.type === 'professionBusiness',
    fetchPaymentTypes,
    unbind,
    payments: paymentsStore.paymentList,
    formatPayments: paymentsStore.formatPayments,
  };
};
